class SimpleExperienceDataProvider {
  constructor(data) {
    this.data = data;
  }
  async getActivations() {
    return await Promise.resolve(this.data.activations);
  }
  async getSettings() {
    return await Promise.resolve(this.data.settings);
  }
  async getDistribution() {
    return await Promise.resolve(this.data.distribution);
  }
  async getTags() {
    return await Promise.resolve(this.data.tags ?? []);
  }
  async getOrganization() {
    return await Promise.resolve(this.data.organization);
  }
}
class SimpleExperiencePlayerTemplateProvider {
  constructor(data) {
    this.data = data;
  }
  async getDefaultMedia() {
    return await Promise.resolve(this.data.defaultMedia);
  }
  async getPlayerTemplate() {
    return await Promise.resolve(this.data.playerTemplate);
  }
}
export {
  SimpleExperienceDataProvider,
  SimpleExperiencePlayerTemplateProvider
};
